<div class="confirm-dialog">
  <div>
    <h2>{{ 'NEW_CONTRACTS.DRAFT_DIALOG.TITLE' | i18nextEager }}</h2>
  </div>
  <span class="text">{{ 'NEW_CONTRACTS.FINISH_CONTRACT' | i18nextEager }}</span>
  <div class="buttons">
    <button class="secondary" (click)="closeDialog('no')">{{ 'COMMONS.NO' | i18nextEager }}</button>
    <button (click)="closeDialog('yes')">{{ 'COMMONS.YES' | i18nextEager }}</button>
  </div>
</div>
